export default __webpack_public_path__ + "static/media/eb708fb02f07647e31830d39f675e18c1582228477248.01ada42b.webp";